
import React from "react";
import { useGetDistributerCategoriesQuery } from "context/distributer/distributerCategoryApiSlice";
import { Controller } from "react-hook-form";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import { Grid, Divider } from "@mui/material";
import { CategorySelect } from "./components/CategorySelect";

const dividersTitle = ["Type du fournisseur","Profil de l'organisation", "Coordonnées fiscales de l'entreprise", "Coordonnées de l'entreprise"];
const dividers = ["genre","companyName","nrc","location.street"];

const FristStep = (props) => {
    
    const { register, control, helperText, errors, distributer, renderFormFields, step } = props;  
  return (
     
    <Grid container  spacing={{ xs: 1, md: 2 }} p={2} >
        
        {step.map((item, index) =>(
            // eslint-disable-next-line
            <React.Fragment key={`item-${index}`} > 
                {dividers.includes(item.name) && (
                <Grid xs={12} item>
                {index !==0 && <Divider/>}
                <MDTypography variant="h6" color="text" >{dividersTitle[dividers.indexOf(item.name)]}</MDTypography>
                </Grid>)}
                {index === 0 && <Grid xs={12} lg={6} item>
                    <MDBox  mb={1}>
                        <CategorySelect 
                            name="category"
                            selected={distributer.category}
                            control={control}
                            fetchData={useGetDistributerCategoriesQuery}
                            register={register}
                            required={false}
                            errors={errors}
                            helperText={helperText.category}
                            size="small"
                        />
                    </MDBox>
                </Grid>}
                <Grid   xs={6} item >
                {renderFormFields(item,index, Controller, 0)}
                </Grid>
            </React.Fragment>
          ))}
    </Grid>
  )
}

export default FristStep